export const REGEX = {
    Email: new RegExp(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/),
    Passport: new RegExp(/^[a-zA-Z0-9]{1,50}$/),
    IdRSA: new RegExp(/^(\d\d)(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])(\d{4})([01])(\d)(\d)$/),
    PhoneRSA: new RegExp(/^(0?)([1-9])(\d{8})$/),
    IdUSA: /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/,
    PhoneUSA: /^(?:(?:\+?1[\s-]*)?(?:\(\s*[2-9]\d{2}\s*\)|[2-9]\d{2})[\s-]*[2-9]\d{2}[\s-]*\d{4})$/,
    IdUK: /^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z]\s?\d{2}\s?\d{2}\s?\d{2}\s?[A-D]$/,
    PhoneUK: /^((((\+44\s?([0–6]|[8–9])\d{3} | \(?0([0–6]|[8–9])\d{3}\)?)\s?\d{3}\s?(\d{2}|\d{3}))|((\+44\s?([0–6]|[8–9])\d{3}|\(?0([0–6]|[8–9])\d{3}\)?)\s?\d{3}\s?(\d{4}|\d{3}))|((\+44\s?([0–6]|[8–9])\d{1}|\(?0([0–6]|[8–9])\d{1}\)?)\s?\d{4}\s?(\d{4}|\d{3}))|((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4})))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/,
    Numbers: new RegExp(/^\d+$/),
};

const ERRORS = {        
    Email: ['Please provide a valid email address'],
    PhoneRSA: ['Please provide a valid South African phone number '],
    PhoneUSA: ['Please provide a valid US phone number'],
    PhoneUK: ['Please provide a valid UK phone number'],
    IdRSA: ['Please provide a valid South African ID number'],
    IdUSA: ['Please provide a valid Social Security Number'],
    IdUK: ['Please provide a valid UK National Insurance number'],
    Passport: ['Please provide a valid passport number'],
    Required: ['This field is required'],
};

/*
function validateIdentification(value: string, isRSARegion: boolean, isUSARegion: boolean, isId: boolean) {
  if (!isId) { 
    return REGEX.Passport.test(value) ? [] : ERRORS.Passport;
  } else if (isRSARegion) {
    return REGEX.IdRSA.test(value) ? [] : ERRORS.IdRSA;
  } else if (isUSARegion) {
    return REGEX.IdUSA.test(value) ? [] : ERRORS.IdUSA;
  } else /*isUKRegion*//* {
    return REGEX.IdUK.test(value) ? [] : ERRORS.IdUK;
  }
}
*/

function validatePhone(value: string, isRSARegion: boolean, isUSARegion: boolean) {
  if (isRSARegion) {
    return REGEX.PhoneRSA.test(value) ? [] : ERRORS.PhoneRSA;
  } else if (isUSARegion) {
    return REGEX.PhoneUSA.test(value) ? [] : ERRORS.PhoneUSA;
  } else /*isUKRegion*/ {
    return REGEX.PhoneUK.test(value) ? [] : ERRORS.PhoneUK;
  }
}

/**
 * Validates input fields based on region and field type
 * @param id - input field identifier
 * @param value - input value to validate
 * @param isRSARegion - whether the app is running in RSA region
 * @param isId - whether using Passport
 * @returns array of error messages, empty if valid
 */
export function validateInput(
  id: string, 
  value: string, 
  isRSARegion: boolean,
  isUSARegion: boolean,
  isId: boolean
) {
  
  if (!value) {
    return ERRORS.Required;
  }

  switch (id) {
    case 'Email':
      return REGEX.Email.test(value) ? [] : ERRORS.Email;
    case 'PhoneNumber':
      return validatePhone(value, isRSARegion, isUSARegion);
    case 'IdNumber':
      return []; // validateIdentification(value, isRSARegion, isUSARegion, isId);
    default:
      return [];
  }
}